module.exports = __webpack_public_path__ + "img/upload_img.03d1e0ac.png";